export const workFlowRoles_actionType = {
    SET_WORKFLOW_ROLES_SUCCESS : 'SET_WORKFLOW_ROLES_SUCCESS',
    SET_WORKFLOW_ROLES_FAILURE : 'SET_WORKFLOW_ROLES_FAILURE',
    GET_WORKFLOW_ROLES_SUCCESS : 'GET_WORKFLOW_ROLES_SUCCESS',
    GET_WORKFLOW_ROLES_FAILURE : 'GET_WORKFLOW_ROLES_FAILURE',
    SELECT_DESELECT_WORKFLOW_ROLES: 'SELECT_DESELECT_WORKFLOW_ROLES',
    RESET_WORKFLOW_ROLES_SUCCESS: 'RESET_WORKFLOW_ROLES_SUCCESS',
    SET_USER_ACCESS_ROLES_MODIFIED: 'SET_USER_ACCESS_ROLES_MODIFIED',
    SET_TRAININGS : 'SET_TRAININGS'
};